<template>
  <div id="home-trending" class="fade-in-fast">
    <HomeFeaturedHeader title="TRENDING" />
    <div class="trending">
      <div class="trending__inner">
        <div class="trending__inner__highlight">
          <div v-if="getFeaturedEpisode" class="trending-highlight">
            <div class="trending-highlight__inner">
              <div class="trending-highlight__inner__image">
                <picture>
                  <img :src="$router.options.imagePath + getFeaturedEpisode.mediaUrl" />
                </picture>
              </div>
              <div class="trending-highlight__inner__info">
                <div class="trending-highlight__inner__info__index">
                  1
                </div>
                <div class="trending-highlight__inner__info__description">
                  <div class="date">
                    {{ getFeaturedEpisode.location.locationname }} -
                    {{ formatSqlDate(getFeaturedEpisode.sqlDate) }}
                  </div>
                  <router-link :to="{ name: 'Show', params: { id: getFeaturedEpisode.permlink } }">
                    <div class="title">
                      {{ getFeaturedEpisode.title }}
                    </div>
                    <div class="artist">
                      w/ {{ getFeaturedEpisode.mainArtist.name }}
                    </div>
                  </router-link>
                  <div class="text" v-html="getFeaturedEpisode.info" />
                  <div v-if="getFeaturedEpisode.hasOwnProperty('subGenres') && $store.getters.getGenresState" class="trending-highlight__inner__info__genres">
                    <GenreButton v-for="genre in getFeaturedEpisode.subGenres"
                                 :key="genre.id"
                                 :genre="genre"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <HomeFeaturedCarousel
            v-if="restEpisodes.length"
            carousel-id="trending-episodes"
            :featured-data="restEpisodes"
            :has-index="true"
            :slides-per-view="3"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import HomeFeaturedHeader from '@/components/sections/HomeFeaturedHeader.vue';
import HomeFeaturedCarousel from '@/components/sections/HomeFeaturedCarousel.vue';
import GenreButton from "@/components/genres/GenreButton.vue";
export default {
  name: 'HomeTrending',
  components: {
    GenreButton,
    HomeFeaturedHeader,
    HomeFeaturedCarousel
  },
  data: () => ({
    trendingEpisodes: [],
    restEpisodes: [],
    getFeaturedEpisode: null
  }),
  mounted() {
    this.getTrendingEpisodes();
  },
  methods: {
    getTrendingEpisodes() {
      axios
        .get(this.$router.options.api + '/front/episode-module?type=TRENDING')
        .then(response => {
          this.trendingEpisodes = response.data;
          this.getFeaturedEpisode = response.data[0].episode;
          this.restEpisodes = this.trendingEpisodes
            .filter(e => e.sorting != 1)
            .sort((a, b) => a.sorting - b.sorting)
            .map(e => ({ ...e.episode }));
        })
        .catch(error => console.error(error));
    },
    formatSqlDate(date) {
      return date
        .split('-')
        .reverse()
        .join('.');
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_home-trending.scss';
</style>
